import React, { Fragment, useState } from 'react';
import { Modal, ProgressBar, Alert } from 'react-bootstrap';
import ECFExternalMailboxEditForm from './ECFExternalMailboxEditForm';
import ECFMailboxesList from './ECFMailboxesList';
import useDataApi from 'utils/useDataApi';
import Notification, { notify } from 'common/Notification';
import request from 'superagent';
import _ from 'lodash';

export default function ECFMailboxesContainer() {
  const [currentlyEditedInbox, setCurrentlyEditedInbox] = useState(null);
  const [{ data, isLoading, isError }, { triggerRefresh }]
    = useDataApi('/rpc/ecf/inbox', []);

  const saveSettings = async (settings) => {
    console.debug('Saving Inbox settings', settings);
    const url = settings.id
      ? `/rpc/ecf/inbox/external/${settings.id}`
      : '/rpc/ecf/inbox/external';
    try {
      await request.post(url).send(settings);
      setCurrentlyEditedInbox(null);
      triggerRefresh();
      notify.success('Inbox settings saved');
    } catch (error) {
      const errorSummary = _.get(error, 'response.body.error', `${error}` );
      notify.error(
        <span>
          We were unable to save your changes!
          <div style={{ border: '1px dotted maroon', padding: '4px', margin: '4px' }}>
            { errorSummary }
          </div>
          Please try again or contact support if problem persists.
        </span>
      );
      return ECFExternalMailboxEditForm.saveErrorSignal(errorSummary);
    }
  };

  const removeInbox = async (inbox) => {
    try {
      await request.delete(`/rpc/ecf/inbox/external/${inbox.id}`);
      notify.success('Inbox successfully disconnected');
      triggerRefresh();
    } catch (error) {
      const errorSummary = _.get(error, 'response.body.error', `${error}` );
      notify.error(
        <span>
          We were unable to disconnect your inbox.
          <div style={{ border: '1px dotted maroon', padding: '4px', margin: '4px' }}>
            { errorSummary }
          </div>
          Please try again or contact support if problem persists.
        </span>
      );
    }
  };


  if (isLoading) return <ProgressBar now={100} active />;

  if (isError) return (
    <Alert bsStyle="danger">
      There has been an error loading ECF Inbox settings.
      Please <a onClick={() => { triggerRefresh(); } }>try again</a> and contact support if the problem persists.
      <pre>
        {`${isError}`}
      </pre>
    </Alert>
  );


  return (
    <Fragment>
      {/*<pre>Got inboxes: {JSON.stringify(data, 0, 2)}</pre>*/}
      <div style={{ marginTop: '22px' }} />

      <ECFMailboxesList
        config={data}
        onConnectNewExternalInboxRequested={() => setCurrentlyEditedInbox({})}
        onEditExternalInboxRequested={setCurrentlyEditedInbox}
        onDisconnectExternalInboxRequested={removeInbox}
      />

      { currentlyEditedInbox &&
        <Modal show>
          <Modal.Header>
            <Modal.Title>
              {
                currentlyEditedInbox.id
                  ? 'Update external mailbox credentials'
                  : 'Connect an external mailbox'
              }
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ECFExternalMailboxEditForm
              settings={currentlyEditedInbox}
              onSaveSettings={saveSettings}
              onCancel={() => setCurrentlyEditedInbox(null)}
            />
          </Modal.Body>
        </Modal>}

      <Notification />
    </Fragment>

  );
}



// WEBPACK FOOTER //
// ./src/User/ECFMailboxes/ECFMailboxesContainer.jsx